export const PRICE_SYMBOL = {
  us: '$',
  uk: '£',
  ca: '$',
  eu: '€',
  fr: '€',
  de: '€',
  nl: '€',
  vn: '₫',
  cl: '$',
  sg: '$',
  ae: 'AED',
} as any

export const languageTerritory = (locale: string) =>
  // https://unicode-org.github.io/cldr-staging/charts/37/supplemental/language_territory_information.html
  ({
    us: 'en-US',
    uk: 'en-GB',
    ca: 'en-CA',
    eu: 'en',
    fr: 'fr-FR',
    au: 'en-AU',
    my: 'en-my',
    'eu-es': 'de-DE',
    'eu-fr': 'de-DE',
    'eu-it': 'de-DE',
    'eu-de': 'de-DE',
    'eu-en': 'en-US',
    'cz-en': 'de-DE',
    'ca-fr': 'fr-FR',
    nl: 'de-DE',
    de: 'de-DE',
    vn: 'vi-vn',
    sg: 'en-sg',
    'ae-en': 'ae-en',
    plus: 'en-us',
    cl: 'es-cl',
    dk: 'en-dk',
    fi: 'en-fi',
    no: 'en-no',
    is: 'en-is',
    se: 'en-se',
    'eu-pl': 'pl-PL',
    es: 'es-es',
    pl: 'pl-PL',
    nz: 'en-NZ',
    'sg-en': 'en-SG',
    'sa-en': 'en-SA',
    'vn-vi': 'vi-VN',
    ie: 'en-IE',
    tw: 'zh-TW',
  })[locale] || ''

export function formatPrice({
  amount,
  currencyCode,
  locale,
  maximumFractionDigits,
  minimumFractionDigits,
  removeTrailingZeros = false,
  currencyDisplay = 'symbol',
}: {
  amount: number
  currencyCode: string
  locale: string
  maximumFractionDigits?: number
  minimumFractionDigits?: number
  removeTrailingZeros?: boolean
  currencyDisplay?: Intl.NumberFormatOptions['currencyDisplay']
}) {
  const code = locale === 'nl' ? 'EUR' : currencyCode || 'USD'
  const localeLanguage = languageTerritory(locale)
  if (!localeLanguage) {
    return null
  }
  const formatCurrency = new Intl.NumberFormat(localeLanguage, {
    style: 'currency',
    currency: code,
    currencyDisplay: currencyDisplay,
    minimumFractionDigits: maximumFractionDigits === 0 ? 0 : minimumFractionDigits,
    maximumFractionDigits,
  })

  let formattedValue = formatCurrency?.format?.(amount)

  if (['eu-de', 'eu-en', 'de', 'eu'].includes(locale)) {
    formattedValue = formattedValue?.toString()?.replace?.(/[\s]/g, '')
  }

  if (removeTrailingZeros) {
    formattedValue = formattedValue
      ?.replace?.(/(\.\d*?[1-9])0+\b/, '$1')
      ?.replace?.(/\.0+\b/, '')
      ?.replace?.(/(,\d*?[1-9])0+\b/, '$1')
      ?.replace?.(/,0+\b/, '')
  }

  return formattedValue
}
